import { ProductCard } from "./productCard";
import { Error } from "../error";

const ProductGrid = ({ productos, isLoading, error, user, onSelectedProduct, refetchProducts }) => {

  if(isLoading) return(<p className="text-white p-1 animate-pulse">Cargando productos...</p>)

  if(error) return(
    
    <section>

    <Error
      mensajeError="Ooops !"
      detallesError={"Ha ocurrido un problema al intentar cargar sus datos."}
      textoBoton={"Volver a intentar"}
      accion={refetchProducts}
    />

    
  </section>)


if(productos.length===0 ) return(<p className="text-white p-1">No se ha encontrado algun producto que coincida con su busqueda...</p>)
    
  return (
    <div className="flex flex-wrap gap-8 justify-evenly">
      {
        productos.map(producto => (
          <ProductCard
            key={producto.id}
            id={producto.id}
            user={user}
            titulo={producto.name}
            descripcion={producto.description}
            precio={producto.price}
            onSelectedProduct={onSelectedProduct}
          />
        ))
      }
    </div>
  );
}

export default ProductGrid;